import type { ChatIdMark, DividerMark, NewsMark } from './ChatEngineTypes'
import { ChatMarks } from '@/engine/ChatEngine/constants'

export const makeChatIdMark = (id: string): ChatIdMark => {
  return `chat:${id}`
}

export const getChatId = (chatIdMark: ChatIdMark) => {
  return chatIdMark.slice(ChatMarks.Chat.length + 1)
}

export const getDividerName = (divider: DividerMark) => {
  return divider.slice(ChatMarks.Divider.length + 1)
}

export const getNewsName = (newsMark: NewsMark) => {
  return newsMark.slice(ChatMarks.News.length + 1)
}
